import { Device } from '@twilio/voice-sdk';
import HttpAgent from '../httpagent.js';

export const types = {
	phoneDeviceReadyType: 'PHONE_DEVICE_READY_UPDATED',
	phoneConnectionUpdatedType: 'PHONE_CONNECTION_UPDATED',
	phoneConnected: 'PHONE_CONNECTED',
	phoneCallStatusUpdated: 'PHONE_CALL_STATUS_UPDATED',
	phoneDeviceUpdated: 'PHONE_DEVICE_UPDATED',
	phoneDeviceCallUpdated: 'PHONE_DEVICE_CALL_UPDATED',
	phoneCallEnded: 'PHONE_CALL_ENDED'
};

const deviceOptions = {
	logLevel: 1,
	codecPreferences: ['opus', 'pcmu']
}

// initialize device before updating the token
window.roydanPhone = new Device('UPDATE_TOKEN', deviceOptions);

HttpAgent.getTwilioToken().then((response) => {
	try {
		window.roydanPhone.updateToken(response.data);
		window.roydanPhone.register();
	} catch (e) {
		console.error('Device instantiation error: ', e);
	}
});

const initialState = {
	device: window.roydanPhone,
	ready: false,
	phoneCallEvent: null,
	activeCall: null
};

export const actionCreators = {
	updateDeviceReady: ready => ({ type: types.phoneDeviceReadyType, data: ready }),
	updateDevice: device => ({ type: types.phoneDeviceUpdated, data: device }),
	updateDeviceActiveCall: activeCall => ({ type: types.phoneDeviceCallUpdated, data: activeCall }),
	endActivePhoneCall: activeCall => ({ type: types.phoneCallEnded, data: null }),
};

export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === types.phoneConnected) {
		return { ...state, agentId : action.data.id };
	}

	if (action.type === types.phoneDeviceReadyType) {
		return { ...state, ready: action.data };
	}

	if (action.type === types.phoneCallStatusUpdated) {
		console.log('phone call status updated', action.data);
		return { ...state, phoneCallEvent: action.data };
	}

	if (action.type === types.phoneDeviceUpdated) {
		console.log('phone device updated', action.data);
		return { ...state, device: action.data };
	}

	if (action.type === types.phoneDeviceCallUpdated) {
		console.log('phone device call updated', action.data);
		return { ...state, activeCall: action.data };
	}

	if (action.type === types.phoneCallEnded) {
		console.log('phone device call ended', action.data);
		return { ...state, activeCall: null };
	}

	return state;
};
